import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: JSON.parse(localStorage.getItem("user") || "{}"),
  error: "",
  loading: false,
  isUserLogout: false,
  errorMsg: false,
  accessToken: localStorage.getItem("accessToken") || null,
  refreshToken: localStorage.getItem("refreshToken") || null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload;
      state.loading = false;
      state.isUserLogout = false;
      state.errorMsg = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload.user || action.payload;
      state.accessToken = action.payload.accessToken || state.accessToken;
      state.refreshToken = action.payload.refreshToken || state.refreshToken;
      state.loading = false;
      state.errorMsg = false;
      state.error = "";
    },
    logoutUserSuccess(state, action) {
      state.user = {};
      state.accessToken = null;
      state.refreshToken = null;
      state.isUserLogout = true;
      state.loading = false;
    },
    reset_login_flag(state) {
      state.error = "";
      state.loading = false;
      state.errorMsg = false;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    updateTokens(state, action) {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
    },
  },
});
export const { apiError, loginSuccess, logoutUserSuccess, reset_login_flag } =
  loginSlice.actions;

export default loginSlice.reducer;
